{
  "commonHeader": {
    "upgradeToPro": "Uppgradera",
    "learnMore": "Läs mer",
    "AIProductivitySuite": {
      "title": "AI-produktivitetspaket",
      "desc": "Förvandla inspirerande diskussioner till imponerande resultat."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Hantera din organisations konto med AI",
        "description": "Få intelligenta svar på dina kontofrågor och hjälp med att navigera i inställningar.",
        "terms": "Genom att använda Zooms beta-funktioner godkänner du {0}",
        "termsText": "villkoren för Zooms betaprogram"
      },
      "diveDeeper": "Fördjupa dig",
      "shareFeedback": "Dela feedback i {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Ställ frågor om organisationens konto",
      "heroInvite": "Hur bjuder jag in en ny användare till mitt konto?",
      "heroGroups": "Hur tilldelar jag användare till grupper?",
      "heroRoles": "Hur hanterar jag roller och behörigheter?"
    },
    "backMainAccount": "Tillbaka till huvudkontot",
    "discoverProducts": "Upptäck produkter",
    "pricing": "Priser",
    "more": "Mer",
    "sidebarExpanded": "utfälld",
    "sidebarCollapsed": "ihopfälld",
    "search": "Sök",
    "users": "Användare",
    "settings": "Kontoinställningar",
    "navigation": "Navigering",
    "clear": "Rensa",
    "searchPlaceholderAll": "Sök efter användare, kontoinställningar eller navigering",
    "searchPlaceholderUsers": "Sök efter användare eller navigering",
    "searchPlaceholderSettings": "Sök efter kontoinställningar eller navigering",
    "searchPlaceholderNav": "Sök i navigering",
    "searchGuide": "Skriv nyckelord för att börja söka",
    "installOnDesktop": "Installera på datorn",
    "downloadCenter": "Nedladdningscenter",
    "getInTouch": "Kontakta oss",
    "featuredProduct": "utvald produkt",
    "logo": {
      "adminCenter": "Administrationscenter",
      "subAccount": "Hanterar underkonto",
      "externalAccount": "Hanterar delegerat konto"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Läs mer",
      "gotIt": "Jag förstår"
    },
    "coachMark": {
      "dvsTipsTitle": "Divisioner är nu tillgängliga",
      "dvsTipsContent": "Divisioner används för att skapa flera instanser av vissa Zoom-produkter inom ditt konto."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Läs mer",
      "gotIt": "Jag förstår"
    },
    "coachMark": {
      "extAccountTipsTitle": "Hantera externa konton",
      "extAccountTipsContent": "Behöver du hantera ett annat konto? Skicka bara en begäran – när de godkänner är du igång!"
    }
  },
  "feedback": {
    "dialogTitle": "Lämna feedback",
    "itemLableForProductArea": "Produktområde",
    "itemLableForSatisfied": "Hur nöjd är du med din upplevelse?",
    "dissatisfied": "Mycket missnöjd",
    "satisfied": "Mycket nöjd",
    "itemLableForFeedback": "Feedback",
    "placeholder": "Tack för dina idéer, kommentarer och förslag.",
    "btnCancel": "Avbryt",
    "btnSubmit": "Skicka in",
    "supportTips": "För teknisk support, besök",
    "btnSupport": "Support.",
    "messages": {
      "success": "Tack för din feedback!",
      "productFailed": "Produktområde krävs.",
      "scoreFailed": "Nöjdhetspoäng krävs."
    },
    "products": {
      "General": "Allmänt",
      "AI": "AI",
      "Apps": "Appar",
      "Calendar": "Kalender",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Möten",
      "Notes": "Anteckningar",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Schemaläggare",
      "Tasks": "Uppgifter",
      "TeamChat": "Teamchatt",
      "WebinarsAndEvents": "Webbseminarier och evenemang",
      "Whiteboard": "Whiteboard",
      "WorkflowAutomations": "Arbetsflödesautomatiseringar",
      "WorkspaceReservation": "Bokning av arbetsplatser",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Denna ansvarsfriskrivning genererades av din kontoadministratör.",
    "cancel": "Avbryt",
    "agree": "Godkänn"
  },
  "shared": {
    "sideMenu": {
      "personal": "Privat",
      "admin": "Admin",
      "menu": "Meny",
      "pinned": "Fäst",
      "pin": "Fäst",
      "unpin": "Ta bort fästning",
      "moveItem": "Flytta objekt",
      "myAccount": "Mitt konto",
      "upgradeToPro": "Uppgradera till Pro",
      "grabbedKeyboard": "{0} greppad. Använd upp- och nedpilarna för att flytta, mellanslag eller Enter för att släppa.",
      "dropped": "{0} släpptes.",
      "releasedUnchanged": "{0} släpptes, positionen är oförändrad.",
      "movedToPosition": "{0} flyttades till position {1} av {2}.",
      "movedUp": "{0} flyttades upp, position {1} av {2}.",
      "movedDown": "{0} flyttades ned, position {1} av {2}.",
      "movedUpNew": "{0} flyttades upp, ny position {1} av {2}",
      "movedDownNew": "{0} flyttades ned, ny position {1} av {2}",
      "cannotMoveFurther": "{0} kan inte flyttas längre.",
      "grabbedMouse": "{0} greppad. Flytta musen för att ändra position, klicka för att släppa, tryck på Escape för att avbryta."
    },
    "item": "Objekt",
    "gotIt": "Uppfattat",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Telefonnumret har lagts till! Du kan använda det för framtida inloggningar och återställning av konton.",
    "mfa_to_signin_phone_success": "{phone} är nu inloggningsnumret för {email}.",
    "login_passkey_bound_success": "Lösenordsnyckeln har skapats"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Följande avancerade hanteringsfunktioner gäller endast för licenserade användare och samarbetsanvändare",
      "licensed_basic": "Följande avancerade hanteringsfunktioner gäller endast för licenserade- och basic-användare",
      "licensed": "Följande avancerade hanteringsfunktioner gäller endast för licenserade användare"
    },
    "support": "- Stöds i kontoinställningar och inställningar för användargrupper",
    "archive_product": {
      "title": "Arkivera möten och webbinarier",
      "detail": "- Möten arkiveras när användare i ditt konto går med. Installera en <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">arkiveringsapp</a> från Zoom App Marketplace för att använda den här inställningen."
    },
    "restrict": {
      "title": "Begränsa användarnas möjlighet att använda valda funktioner när de deltar i ett möte",
      "detail": "- Valda funktioner kan inte användas även om mötesvärdar aktiverar dem för möten."
    },
    "meeting_integration": {
      "title": "Aktivera DLP-integrering (dataförlustskydd) i chatt under möten",
      "detail": "- När DLP är aktiverat tillämpas det på både offentliga och privata chattmeddelanden som en deltagare skickar. Meddelandena kommer att raderas omedelbart om deltagarna i ett möte (internt/externt) chattar och ett meddelande bryter mot värdorganisationens efterlevnadspolicyer."
    },
    "chat_tool": {
      "title": "Etikettverktyg för chatt",
      "detail": "- Identifiera angivna nyckelord och textmönster i delat innehåll och förhindra användare från att dela oönskade meddelanden"
    },
    "information_barriers": {
      "title": "Informationsbarriärer",
      "detail": "- Informationsbarriärer styr kommunikationen mellan vissa användare i efterlevnadssyfte. Begränsningar kan införas för möten och chattar mellan användare i två grupper och av vissa användares användning av specifika funktioner (t.ex. chatt under möte, skärmdelning och filöverföring). Dessa begränsningar förhindrar utbyte av konfidentiell information mellan obehöriga användare."
    },
    "dashboard": {
      "title": "Kontrollpanel",
      "detail": "- För möten > kontrollpanelen för tidigare möten visas endast de 3 senaste månadernas data för vissa användare"
    },
    "reports": {
      "title": "Rapporter",
      "detail": "- Vissa användarrapporter visar data i endast 3 månader för vissa användare: ansvarsfriskrivningsrapport, deltagarloggrapport, rapport om administratörsaktivitetsloggar och rapport om in-/utloggning"
    },
    "close": "Stäng"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Din {planName} kommer att avslutas {cancelDate}. Före det datumet kan du återaktivera dina webbinarielicenser. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att få tillgång till data för befintliga webbinarier. Efter {dataLossDate} kommer du att förlora alla data för webbinarier.",
            "nonAdmin": "Din {planName} kommer att avslutas {cancelDate}. Senast det datumet kan du kontakta din kontoadmin för att återaktivera dina webbinarielicenser. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att få tillgång till data för befintliga webbinarier. Efter {dataLossDate} kommer du att förlora alla data för webbinarier på ditt konto."
          },
          "admin": "Din {planName} kommer att avslutas {cancelDate}. Senast det datumet kan du återaktivera dina webbinarielicenser. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att få tillgång till {supportContent} för befintliga webbinarier. Efter {dataLossDate} kommer du att förlora alla data för webbinarier på ditt konto.",
          "nonAdmin": "Din {planName} kommer att avslutas {cancelDate}. Senast det datumet kan du kontakta din kontoadmin för att återaktivera dina webbinarielicenser. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att få tillgång till {supportContent} för befintliga webbinarier. Efter {dataLossDate} kommer du att förlora alla data för webbinarier på ditt konto."
        },
        "expired": {
          "admin": "Din {planName} har avslutats. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att få tillgång till {supportContent} för befintliga webbinarier eller köpa Zoom Webinars igen för att återställa dataåtkomsten. Efter {dataLossDate} kommer du att förlora alla data för webbinarier på ditt konto.",
          "nonAdmin": "Din {planName} har avslutats. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att få tillgång till {supportContent} för befintliga webbinarier eller kontakta din kontoadmin för att köpa Zoom Webinars igen och återställa dataåtkomsten. Efter {dataLossDate} kommer du att förlora alla data för webbinarier på ditt konto."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Din {planName} kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du endast se befintliga webbinarier och deras resurser. Du kan när som helst avsluta pausen och återuppta prenumerationen på dina webbinarielicenser.",
            "nonAdmin": "Din {planName} kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du endast se befintliga webbinarier och deras resurser. Du kan kontakta din kontoadmin för att avsluta pausen och återuppta prenumerationen på dina webbinarielicenser när som helst."
          },
          "admin": "Din {planName} kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du endast se {supportContent}. Du kan när som helst avsluta pausen och återuppta prenumerationen på dina webbinarielicenser.",
          "nonAdmin": "Din {planName} kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du endast se {supportContent}. Du kan kontakta din kontoadmin för att avsluta pausen och återuppta prenumerationen på dina webbinarielicenser när som helst."
        },
        "active": {
          "webinars": {
            "admin": "Din {planName} är pausad i {pauseDuration} från och med {pausedDate}. Under pausen kan du bara se befintliga webbinarier. Du kan när som helst återuppta prenumerationen på dina webbinarielicenser.",
            "nonAdmin": "Din {planName} är pausad i {pauseDuration} från och med {pausedDate}. Under pausen kan du bara se befintliga webbinarier. Kontakta gärna din kontoadmin för att återuppta prenumerationen på dina webbinarielicenser när som helst."
          },
          "admin": "Din {planName} är pausad i {pauseDuration}. Under pausen kan du bara se {supportContent} för befintliga webbinarier. Du kan när som helst återuppta prenumerationen på dina webbinarielicenser.",
          "nonAdmin": "Din {planName} är pausad i {pauseDuration}. Under pausen kan du bara se {supportContent} för befintliga webbinarier. Kontakta gärna din kontoadmin för att återuppta prenumerationen på dina webbinarielicenser när som helst."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Din {planName}-licens kommer att pausas {pausedDate} i {pauseDuration}. Tilldela den här användaren en aktiv licens innan pausen börjar för att fortsätta vara värd för webbinarier. Du kan också ta bort pausen för att fortsätta använda den här licensen.",
            "nonAdmin": "Din {planName}-licens kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du endast se befintliga webbinarier och deras resurser. Kontakta din kontoadmin angående att tilldela en aktiv licens till ditt konto innan pausen startar för att fortsätta vara värd för webbinarier."
          },
          "active": {
            "admin": "Din {planName}-licens är pausad i {pauseDuration} från och med {pausedDate}. Under pausen kan du bara se befintliga webbinarier. Du kan när som helst återuppta prenumerationen på licensen eller tilldela en aktiv licens till ditt konto för att fortsätta vara värd för webbinarier.",
            "nonAdmin": "Din {planName}-licens är pausad i {pauseDuration} från och med {pausedDate}. Under pausen kan du bara se befintliga webbinarier. Kontakta din kontoadmin angående att tilldela en aktiv licens till ditt konto för att fortsätta vara värd för webbinarier under pausen."
          }
        },
        "cancel": {
          "active": {
            "admin": "Din {planName}-licens kommer att avslutas {cancelDate}. För att fortsätta hålla webbinarier, återaktivera din webbinarielicens eller tilldela en aktiv licens innan avslutandet träder i kraft. Om ingen åtgärd vidtas har du en respitperiod från {supportStartDate} - {supportEndDate} för att kontakta kundsupporten och hämta dina befintliga webbinariedata. Efter {dataLossDate} raderas all webbinariedata som är kopplad till ditt konto permanent.",
            "nonAdmin": "Din {planName}-licens kommer att avslutas {cancelDate}. För att fortsätta hålla webbinarier, kontakta din kontoadmin för att återaktivera din webbinarielicens eller tilldela en aktiv licens innan avslutandet träder i kraft. Om ingen åtgärd vidtas har du en respitperiod från {supportStartDate} - {supportEndDate} för att kontakta kundsupporten och hämta dina befintliga webbinariedata. Efter {dataLossDate} raderas all webbinariedata som är kopplad till ditt konto permanent."
          },
          "expired": {
            "admin": "Din {planName}-licens har avslutats. Tilldela en aktiv licens till den här användaren för att fortsätta vara värd för webbinarier. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att hämta data för befintliga webbinarier.",
            "nonAdmin": "Din {planName}-licens har avslutats. Kontakta din kontoadmin angående att tilldela en aktiv licens till din profil för att fortsätta vara värd för webbinarier. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att hämta data för befintliga webbinarier."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Din {planName}-licens kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du endast se {supportContent} från tidigare webbinarier. Tilldela den här användaren en aktiv licens innan pausen börjar för att fortsätta komma åt webbinarieresurserna. Du kan också ta bort pausen för att fortsätta använda den här licensen.",
              "nonAdmin": "Din {planName}-licens kommer att pausas {pausedDate} i {pauseDuration}. Under pausen kan du bara se {supportContent}. Kontakta din kontoadmin angående att tilldela en aktiv licens till din profil för att fortsätta komma åt webbinarieresurserna."
            },
            "active": {
              "admin": "Din {planName} är pausad i {pauseDuration} från och med {pausedDate}. Under pausen kan du bara se {supportContent} för befintliga webbinarier. Tilldela ditt konto en aktiv licens för att fortsätta komma åt webbinarieresurserna. Du kan också återuppta prenumerationen på den här licensen när som helst.",
              "nonAdmin": "Din {planName} är pausad i {pauseDuration} från och med {pausedDate}. Under pausen kan du bara se {supportContent} för befintliga webbinarier. Kontakta din kontoadmin angående att tilldela en aktiv licens till ditt konto för att fortsätta vara värd för webbinarier under pausen."
            }
          },
          "cancel": {
            "active": {
              "admin": "Din {planName} kommer att avslutas {cancelDate}. Tilldela ditt konto en aktiv licens innan uppsägningen träder i kraft för att fortsätta vara värd för webbinarier. Du kan återaktivera den här licensen före {cancelDate}. Från {supportStartDate}–{supportEndDate} kan du kontakta kundsupporten för att hämta {supportContent} för befintliga webbinarier.",
              "nonAdmin": "Din {planName}-licens kommer att avslutas {cancelDate}. För att fortsätta hålla webbinarier, kontakta din kontoadmin för att återaktivera din webbinarielicens eller tilldela en aktiv licens innan avslutandet träder i kraft. Om ingen åtgärd vidtas har du en respitperiod från {supportStartDate} - {supportEndDate} för att kontakta kundsupporten och hämta {supportContent} för dina befintliga webbinarier. Efter {dataLossDate} raderas all webbinariedata som är kopplad till ditt konto permanent."
            },
            "expired": {
              "admin": "Din {planName}-licens har avslutats. Tilldela en aktiv licens till den här användaren för att fortsätta vara värd för webbinarier. Från {supportStartDate} till {supportEndDate} kan du kontakta kundsupporten för att hämta {supportContent} för befintliga webbinarier.",
              "nonAdmin": "Din {planName}-licens har avslutats. Kontakta din kontoadmin angående att tilldela en aktiv licens till din profil för att fortsätta vara värd för webbinarier. Från {supportStartDate} till {supportEndDate} kan du kontakta kundsupporten för att hämta {supportContent} för befintliga webbinarier."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "data",
        "recordingsAndTranscripts": "inspelningar och avskrifter",
        "reports": "rapporter",
        "summaries": "sammanfattningar",
        "dashboard": "kontrollpaneler"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "Inspelningar och avskrifter av tidigare webbinarier",
          "reports": "rapporter för tidigare webbinarier",
          "summaries": "sammanfattningar av tidigare webbinarier",
          "dashboard": "kontrollpaneler för tidigare webbinarier",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Återaktivera plan",
    "purchasePlan": "Köp plan",
    "removePause": "Avsluta paus",
    "resumeSubscription": "Återuppta prenumeration",
    "month": "månad",
    "months": "månader",
    "assignLicense": "Tilldela licens"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Jag förstår"
    },
    "coachMark": {
      "tipsTitle": "Adressbok blir Kundkatalog",
      "tipsContent": "I oktober 2026-versionen byter vi namn på Adressbok till Kundkatalog för att bättre återspegla syftet. All befintlig funktionalitet, behörigheter och arbetsflöden förblir desamma – du fortsätter att hantera kundlistor (adressböcker) och kontakter precis som idag."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Vi uppdaterar våra villkor och policyer",
    "agreeSub": "Genom att fortsätta använda Zoom accepterar du de uppdaterade <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Användarvillkoren</a> och <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Integritetspolicyn</a>.",
    "continue": "Fortsätt"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Tillbaka till huvudkontot",
      "backLinkedAccount": "Tillbaka till det länkade kontot",
      "backMyAccount": "Tillbaka till Mitt konto",
      "myAccount": "Mitt konto"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion är nu tillgängligt för ditt konto",
      "desc": "Här är några av de Custom AI Companion-funktioner du kan använda i ditt konto:",
      "studioTitle": "AI Studio",
      "studioDesc": "Anpassa AI Companion-upplevelsen för din organisation.",
      "integrationsTitle": "Tredjepartsintegrationer",
      "integrationsDesc": "Använd tredjepartsappar för att effektivisera dina arbetsflöden.",
      "clipsTitle": "Anpassade avatarer för Zoom Clips",
      "clipsDesc": "Låt användare personalisera AI-avatarer att använda i sina clips."
    },
    "coachMark": {
      "licenseTitle": "Du har {0} Custom AI Companion-licenser att tilldela",
      "licenseDesc": "Tilldela dessa licenser under <b>Användarhantering</b> så att dina användare kan börja använda avancerade AI Companion-funktioner.",
      "settingTitle": "Titta på Custom AI Companion-inställningarna för ditt konto",
      "settingDesc": "Konfigurera inställningar för varje Custom AI-funktion under <b>Kontoinställningar</b>. <a href=\"/account/setting?tab=aicompanion\">Gå till inställningar</a>",
      "groupSettingTitle": "Titta på Custom AI-inställningarna för din grupp",
      "groupSettingDesc": "Konfigurera inställningar för varje Custom AI-funktion under <b>Gruppinställningar</b>. <a href=\"/account/group\">Gå till inställningar</a>"
    },
    "common": {
      "learnMore": "Läs mer",
      "quickTour": "Ta en kort rundtur",
      "remindLater": "Påminn mig senare",
      "dismiss": "Stäng",
      "next": "Nästa",
      "back": "Tillbaka",
      "gotIt": "Jag förstår",
      "goToSetting": "Gå till inställning"
    },
    "aiPanelToast": "Aktivera inställningen <b>AI-panel i Zoom Workplace</b> för att börja använda alla Custom AI Companion-funktioner."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Jag förstår",
      "next": "Nästa",
      "remindMeLater": "Påminn mig senare",
      "waffleMenuTitle": "Välkommen till den nya Zoom-webbupplevelsen",
      "waffleMenuDesc": "Kom åt Zoom-produkter var du än är med vår nya <b>produktmeny.</b>",
      "profileMenuTitle": "Mitt konto",
      "profileMenuDesc": "Hitta din profil och dina personliga inställningar i <b>Mitt konto.</b>",
      "personalTitle": "Få tillgång till allt du behöver",
      "personalDesc": "<b>Mitt konto</b> innehåller din profil, inställningar, mötesavskrifter och mer.",
      "adminCenterTitle": "Hitta organisationsinställningar i Admin Center",
      "adminCenterDesc": "Ditt nya <b>Admin Center</b> låter dig konfigurera produkter och justera inställningar för hela din organisation.",
      "adminMenuForTitle": "Använd Admin Center som ett proffs",
      "adminMenuForAccountSettings": "Under <b>Inställningar</b> kommer du åt standardproduktinställningar för alla i din organisation.",
      "adminMenuForContentManagementItem": "Under <b>Innehållshantering</b> kan du hantera allt användargenererat innehåll.",
      "adminMenuForConfigureProductsItem": "Under <b>Produktkonfiguration</b> kan du konfigurera och slutföra adminuppgifter för dina produkter.",
      "adminMenuForNoItems": "I det nya admincentret kan du enklare komma åt och hantera dina kontoinställningar och produkter. Du kan också fästa objekt du vill ha för snabbare åtkomst.",
      "tryNewExperience": "Prova den nya upplevelsen",
      "tryNewExperienceDetail": "Prova! Du kan alltid återgå till den här, den klassiska upplevelsen.",
      "tryNewExperienceTitle": "Nytt utseende för Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Alla rättigheter förbehållna.",
    "terms": "Villkor",
    "privacy": "Integritet",
    "trust_center": "Trust Center",
    "acceptable_use_guidelines": "Riktlinjer för acceptabel användning",
    "legal": "Juridik",
    "do_not_sell_my_personal_information": "Dina integritetsval",
    "cookie_preferences": "Cookieinställningar",
    "pricing": "Planer och priser",
    "feedback": "Feedback",
    "contact_us": "Kontakta oss"
  },
  "termChange": {
    "changeTerm": {
      "title": "Avtal om ändring av förnyelseperiod",
      "quoteNumbers": "Ändrad(e) orderblankett(er) - {0}",
      "content1": "Genom att acceptera dessa villkor samtycker Kunden till att ändra den befintliga förnyelseperioden för prenumerationen för alla orderblanketter mellan Zoom Communications, Inc. (“Zoom”) och Kunden genom att ändra den avtalade perioden från en månadsvis förnyelseperiod till en {0}. I utbyte mot detta åtagande samtycker Zoom till att behålla Kundens aktuella priser under den första nya förnyelseperioden.",
      "content2": "Kunden förstår att den nya förnyelseperioden på {0} gäller när Kunden klickar på ”Jag godkänner” nedan, och att den nya förnyelseperioden inleds dagen efter att Kundens aktuella månadsvisa förnyelseperiod upphör. Denna nya förnyelseperiod gäller alla orderblanketter som för närvarande är i kraft med Zoom, och alla framtida förnyelseperioder enligt dessa orderblanketter kommer att ha samma längd.",
      "content3": "Kunden bekräftar att den enda ändringen avser förnyelseperioden och att alla övriga villkor i varje orderblankett som för närvarande är i kraft med Zoom förblir oförändrade och i full kraft och verkan i enlighet med sina villkor.",
      "content4": "Du samtycker vidare till att detta är ett avtalsmässigt åtagande mellan Kunden och Zoom.",
      "agreementText": "Genom att klicka på ”Jag godkänner” intygar du att du är behörig att göra denna ändring på Kundens vägnar och att Kunden godkänner de villkor som anges ovan.",
      "IDecline": "Jag avböjer",
      "IAccept": "Jag godkänner"
    },
    "unableToChangeTerm": {
      "title": "Det går inte att ändra förnyelseperioden",
      "content": "Ditt konto är inte berättigat att uppdatera förnyelseperioden. <a target=\"_blank\" href=\"{0}\">Kontakta oss</a> om detta är ett fel.",
      "acceptedTitle": "Förnyelseperioden har förlängts",
      "acceptedContent": "Du har redan godkänt förnyelsevillkoren. Ingen ytterligare åtgärd krävs.",
      "GotIt": "Jag förstår"
    },
    "termLengthUpdated": "Förnyelseperiodens längd har uppdaterats till {0} månader.",
    "termLengthUnchanged": "Periodlängden är oförändrad.",
    "errorInfo": "Ett serverfel uppstod. Försök igen.",
    "x12MonthTerm": "tolvmånadersperiod (12)",
    "x24MonthTerm": "tjugofyramånadersperiod (24)",
    "x12MonthTermPlural": "tolv (12) månader",
    "x24MonthTermPlural": "tjugofyra (24) månader"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Ditt konto är schemalagt att uppdateras till den <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nya Zoom-webbupplevelsen</a> den {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Granska när du ska uppdatera</a>"
    },
    "completed": {
      "content": "Den nya Zoom-webbupplevelsen är nu aktiv för alla användare på ditt konto. Användare ser det uppdaterade gränssnittet vid nästa inloggning."
    }
  }
}
